/**
 * lenis.js — Shared Lenis Smooth Scroll Manager
 *
 * Single owner of the global Lenis instance (window.lenis).
 * Other modules should import ensureLenis() or call getLenis()
 * rather than creating their own instance.
 *
 * Lenis is initialised if:
 *   - The <body> has [data-smooth-scroll] (site-wide opt-in), OR
 *   - A module explicitly calls ensureLenis()
 *
 * The opt-in check is handled by initLenis(), called from main.js.
 */

const SMOOTH_SCROLL_ATTR = "data-smooth-scroll";

/**
 * Create or reuse a global Lenis instance.
 * Returns null if Lenis is not available.
 */
export function ensureLenis() {
  if (typeof Lenis === "undefined") return null;
  if (window.lenis) return window.lenis;

  const lenis = new Lenis({ autoRaf: true });
  window.lenis = lenis;
  return lenis;
}

/**
 * Get the existing Lenis instance (if any).
 * Does not create one — use ensureLenis() for that.
 */
export function getLenis() {
  return window.lenis || null;
}

/**
 * Initialise Lenis if the page has opted in via [data-smooth-scroll] on <body>.
 * Called from main.js on DOMContentLoaded.
 */
export function initLenis() {
  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReduced) return;

  if (!document.body.hasAttribute(SMOOTH_SCROLL_ATTR)) return;

  ensureLenis();
}
